import { GraphDataObject, Segment } from '../../types';
import { returnSummarySegments, returnGridTable } from './helpers';

interface EndpointsProps {
  [key: string]: {
    [key: string]: {
      endpoint: string;
      id: string;
      title: string;
      index: number;
    }[];
  };
}

interface HandleEndpoints {
  [key: string]: {
    [key: string]: (id: string, data: any) => (Segment | null)[] | GraphDataObject[];
  };
}

export const endpoints: EndpointsProps = {
  summary: {
    segments: [
      { endpoint: '/summary/sales', id: 'glanceSales', title: 'Glance Sales', index: 0 },
      { endpoint: '/summary/media', id: 'glanceMedia', title: 'Glance Media', index: 1 }
    ]
  },
  grid: {
    segments: [
      { endpoint: '/atglance/grid/sales', id: 'glanceGridSales', title: 'Glance Grid Sales', index: 0 },
      { endpoint: '/atglance/grid/media', id: 'glanceGridMedia', title: 'Glance Grid Media', index: 1 }
    ]
  }
};

export const handleFetchEndpoint: HandleEndpoints = {
  summary: {
    segments: (id, data) => returnSummarySegments(id, data)
  },
  grid: {
    grid: (id, data) => returnGridTable(id, data)
  }
};
